import { defineStore } from 'pinia';

interface UiStoreState {
   isSubscriptionCtaModalOpen: boolean;
   subscriptionCtaContext: 'course' | 'blog' | null;
}

interface UiStoreActions {
   openSubscriptionCtaModal(context?: 'course' | 'blog'): void;
   closeSubscriptionCtaModal(): void;
}

const useUiStore = defineStore<string, UiStoreState, {}, UiStoreActions>(
   'ui',
   {
      state: (): UiStoreState => {
         return {
            isSubscriptionCtaModalOpen: false,
            subscriptionCtaContext: null,
         };
      },
      actions: {
         openSubscriptionCtaModal(context: 'course' | 'blog' = 'course') {
            this.subscriptionCtaContext = context;
            this.isSubscriptionCtaModalOpen = true;
         },

         closeSubscriptionCtaModal() {
            this.isSubscriptionCtaModalOpen = false;
            this.subscriptionCtaContext = null;
         },
      },
   },
);

export default useUiStore;